module.exports = __webpack_public_path__ + "static/images/DINMittelschriftStd.4e887e8.svg";